export const zIndex = {
  footer: 1000,
  stickyCTABtn: 300,
  heroBlock: 200,
  header: 100,
  ieNotification: 4,
  duckToolsPanel: 1000,
  callUsTooltip: 10000,
};
